import React from 'react';

import classnames from 'classnames';

import styles from './Card.module.scss';

type CardProps = {
  children: React.ReactNode;
  className?: string;
  showPadding?: boolean;
};

const Card = ({ children = null, className = '', showPadding = false }: CardProps) => {
  const classes = classnames(styles.card, className, {
    [styles.cardwithpadding]: !!showPadding,
  });
  return <div className={classes}>{children}</div>;
};

export default Card;
